/**
 * Section — full-width band with one of three tones,
 * wrapping content in the standard max-width container.
 */
export default function Section({
  id,
  tone = 'cream',
  children,
  py = 'var(--space-10)',
  label,
}) {
  const tones = {
    cream: { background: 'var(--cream)' },
    sand: { background: 'var(--sand)' },
    ink: { background: 'var(--ink)', color: 'var(--cream)' },
  };
  return (
    <section
      id={id}
      data-screen-label={label}
      style={{ ...tones[tone], paddingTop: py, paddingBottom: py }}
    >
      <div
        style={{
          maxWidth: 'var(--maxw-content)',
          margin: '0 auto',
          padding: '0 var(--gutter)',
        }}
      >
        {children}
      </div>
    </section>
  );
}
